import React from "react";
import PropTypes from "prop-types";

export default function CardBody(props) {
  const { className, children, plain, profile, ...rest } = props;

  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  children: PropTypes.node,
};
